import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { generateCompStylers } from '../../../common/utils/styles';
import css from './MobMenu.module.scss';
import classnames from 'classnames';
const MobMenu = ({ compStyles, children, expanded, removeMenu }) => {
    const menuClick = useCallback((e) => e.stopPropagation(), []);
    const { stylers, classes } = generateCompStylers(compStyles);
    return (
        <div
            className={classnames(css.default, classes.MenuBlockStyles)}
            style={{
                ...stylers.MenuBlockStyles,
                ...(expanded
                    ? {
                          transform: 'translateX(0)',
                          zIndex: '9999',
                          pointerEvents: 'auto'
                      }
                    : {
                          transform: 'translateX(-100%)',
                          pointerEvents: 'none'
                      })
            }}
            onClick={() => removeMenu(false) || {}}
        >
            <div
                style={{ ...stylers.MenuStyles, ...(expanded ? {} : stylers.MenuStylesClosed) }}
                className={classnames(classes.MenuStyles, expanded ? '' : classes.MenuStylesClosed)}
                onClick={menuClick}
            >
                {children}
            </div>
        </div>
    );
};

MobMenu.propTypes = {
    styles: PropTypes.object,
    expanded: PropTypes.bool,
    removeMenu: PropTypes.func,
    className: PropTypes.string
};

export default MobMenu;
